import ENSListPage from './ENSListPage.container'
export default ENSListPage
